// Puts last api response action type & data into state, along with error message if applicable.
// Allows components to respond to async actions they have initiated (eg show notification or
// error message).

export default function apiResponse(
  state = { actionType: null, error: null, statusCode: null, id: 0 },
  action
) {
  if (action.apiResponse) {
    const actionData = Object.assign({}, action);
    if (!action.propogateResponse) {
      delete actionData.response;
    }

    return {
      actionType: action.type,
      error: action.error,
      statusCode: action.statusCode,
      id: state.id + 1,
      action: actionData,
    };
  } else if (action.apiRequest) {
    return {
      actionType: null,
      error: null,
      statusCode: null,
      action: {},
      id: state.id,
    };
  }

  return state;
}
